(function () {
  var syncing = false;
  var PROP_BUNDLE = '_Solinia LP bundle';
  var PROP_GIFT = '_Solinia LP gift';
  var PROP_CREAM = '_Landing page offer';
  var THRESHOLD_SOURCE = 'solinia-lp-seal-gift-threshold';
  var THRESHOLD_BATCH = 'solinia-lp-seal-gift-threshold-batch';
  var GIFT_UNLOCK_QTY = {
    'Free Shipping': 2,
    'The Restless Legs Rescue Guide': 2,
    'Deep Sleep Shower Steamers - 7 Pack': 3
  };

  function getSelectedJarCount(root) {
    var checked = root.querySelector('.lp-product__variant-input:checked');
    return checked ? Number(checked.value) : null;
  }

  function getVariantIdForJar(root, jarCount) {
    var checked = root.querySelector('.lp-product__variant-input:checked');
    if (checked && checked.getAttribute('data-variant-id')) {
      return checked.getAttribute('data-variant-id');
    }
    return root.getAttribute('data-lp-variant-' + jarCount) || '';
  }

  function syncFormVariant(root, jarCount) {
    if (!jarCount) return false;

    var form = root.querySelector('[data-product-form]');
    if (!form) return false;

    var variantId = getVariantIdForJar(root, jarCount);
    var variantInput =
      form.querySelector('[data-lp-variant-input]') ||
      form.querySelector('input[name="id"][type="hidden"]') ||
      form.querySelector('input[name="id"]:not([type="radio"])');
    var qtyInput = form.querySelector('[data-lp-quantity-input]') || form.querySelector('input[name="quantity"]');

    if (!variantInput || !variantId) return false;

    var nextId = String(variantId);
    if (variantInput.value !== nextId) {
      variantInput.value = nextId;
    }
    if (variantInput.getAttribute('value') !== nextId) {
      variantInput.setAttribute('value', nextId);
    }

    variantInput.dispatchEvent(new Event('input', { bubbles: true }));
    variantInput.dispatchEvent(new Event('change', { bubbles: true }));

    if (qtyInput && qtyInput.value !== '1') {
      qtyInput.value = '1';
      qtyInput.setAttribute('value', '1');
    }

    if (typeof window.SealSubs !== 'undefined' && typeof window.SealSubs.refresh === 'function') {
      window.SealSubs.refresh();
    }

    return true;
  }

  function isSealOptionReady(form, index) {
    var options = getSealOptions(form);
    var radio = options[index];
    if (!radio) return false;

    var container = radio.closest('.sls-option-container');
    return Boolean(container && !container.classList.contains('sls-disabled-option-container'));
  }

  function getJarsPerUnit(item) {
    if (!item || !item.properties) return 1;
    var offer = item.properties[PROP_CREAM] || '';
    var match = String(offer).match(/^(\d+)\s+Jar/);
    return match ? parseInt(match[1], 10) : 1;
  }

  function getEffectiveJarCount(item, quantity) {
    var qty = typeof quantity === 'number' ? quantity : item && item.quantity;
    return getJarsPerUnit(item) * (parseInt(qty, 10) || 1);
  }

  function getPurchaseMode(root) {
    var checked = root.querySelector('.lp-product__mode-input:checked');
    return checked && checked.value === 'once' ? 'once' : 'subscribe';
  }

  function getSealOptions(form) {
    var container = form.querySelector('.sls-purchase-options-container');
    if (!container) return [];
    return Array.prototype.slice.call(container.querySelectorAll('input.sls-option'));
  }

  function getSealOptionIndex(jarCount, mode) {
    if (mode === 'once') return 0;
    return jarCount || 1;
  }

  function syncSellingPlanFromSeal(form, radio) {
    var planInput = form.querySelector('input[name="selling_plan"]');
    if (!planInput || !radio) return;

    if (radio.getAttribute('data-type') === 'one_time' || radio.value === 'one_time') {
      planInput.value = '';
      return;
    }

    var container = radio.closest('.sls-option-container');
    var select = container ? container.querySelector('select[name="subs_interval"]') : null;
    if (select && select.value) {
      planInput.value = select.value;
    }
  }

  function selectSealOptionByIndex(form, index) {
    var options = getSealOptions(form);
    if (!options.length) return false;

    var radio = options[index];
    if (!radio) return false;

    if (radio.checked) {
      syncSellingPlanFromSeal(form, radio);
      return true;
    }

    syncing = true;

    var clickable = radio.closest('[role="radio"]') || radio.parentElement || radio;
    clickable.click();

    if (!radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event('input', { bubbles: true }));
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }

    syncSellingPlanFromSeal(form, radio);
    syncing = false;
    return radio.checked;
  }

  function getSellingPlanId(form) {
    if (!form) return '';

    var checked = form.querySelector('.sls-option:checked');
    if (checked) {
      if (checked.getAttribute('data-type') === 'one_time' || checked.value === 'one_time') {
        return '';
      }
      var container = checked.closest('.sls-option-container');
      var select = container ? container.querySelector('select[name="subs_interval"]') : null;
      if (select && select.value) return select.value;
    }

    var planInput = form.querySelector('input[name="selling_plan"]');
    if (planInput && planInput.value) return planInput.value;

    return '';
  }

  function isSealRadioReady(radio) {
    if (!radio) return false;
    var container = radio.closest('.sls-option-container');
    return Boolean(container && !container.classList.contains('sls-disabled-option-container'));
  }

  function selectSealOptionRadio(form, radio) {
    if (!radio) return false;

    if (radio.checked) {
      syncSellingPlanFromSeal(form, radio);
      return true;
    }

    syncing = true;

    var clickable = radio.closest('[role="radio"]') || radio.parentElement || radio;
    clickable.click();

    if (!radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event('input', { bubbles: true }));
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }

    syncSellingPlanFromSeal(form, radio);
    syncing = false;
    return radio.checked;
  }

  function numericPlanId(value) {
    if (value === null || value === undefined) return '';
    return String(value).split('/').pop() || '';
  }

  function getExpectedPlanId(root) {
    var checked = root.querySelector('.lp-product__variant-input:checked');
    if (!checked) return null;
    var raw = checked.getAttribute('data-selling-plan-id');
    if (raw === null) return null; // attribute absent -> legacy ordinal markup
    return numericPlanId(raw);
  }

  function findSealOptionByPlanId(form, planId) {
    var options = getSealOptions(form);
    for (var i = 0; i < options.length; i++) {
      var container = options[i].closest('.sls-option-container');
      var select = container ? container.querySelector('select[name="subs_interval"]') : null;
      if (select && numericPlanId(select.value) === planId) return options[i];
    }
    return null;
  }

  function findSealOneTimeOption(form) {
    var options = getSealOptions(form);
    for (var i = 0; i < options.length; i++) {
      if (options[i].getAttribute('data-type') === 'one_time' || options[i].value === 'one_time') {
        return options[i];
      }
    }
    return options[0] || null;
  }

  function syncSealWidget(root) {
    var form = root.querySelector('[data-product-form]');
    if (!form || !form.querySelector('.sls-option')) return false;

    var jarCount = getSelectedJarCount(root);
    var mode = getPurchaseMode(root);

    if (jarCount) syncFormVariant(root, jarCount);

    if (mode === 'once') {
      // Never let a stale plan ride along on a one-time purchase.
      var planInput = form.querySelector('input[name="selling_plan"]');
      if (planInput) planInput.value = '';
      var oneTime = findSealOneTimeOption(form);
      if (!oneTime) return true; // widget absent/odd: one-time stays purchasable
      if (!isSealRadioReady(oneTime)) return false;
      return selectSealOptionRadio(form, oneTime);
    }

    var expected = getExpectedPlanId(root);
    if (expected !== null) {
      // Plan-identity path: match ONLY the variant's own plan. Widget option ORDER is
      // irrelevant here by construction; never fall through to ordinal with a known id
      // (an ordinal pick after a failed match is exactly the 2026-07-01 outage class).
      if (!expected) return false; // variant has no allocation yet -> keep retrying; submit guard blocks
      var match = findSealOptionByPlanId(form, expected);
      if (!match || !isSealRadioReady(match)) return false;
      return selectSealOptionRadio(form, match);
    }

    // Legacy ordinal fallback: only for markup without data-selling-plan-id.
    var index = getSealOptionIndex(jarCount, mode);
    if (!isSealOptionReady(form, index)) return false;

    return selectSealOptionByIndex(form, index);
  }

  function waitForWidgetAndSync(root, attempts) {
    if (syncSealWidget(root)) return;

    if (attempts > 0) {
      window.setTimeout(function () {
        waitForWidgetAndSync(root, attempts - 1);
      }, 250);
    }
  }

  function getBundleId(item) {
    if (!item || !item.properties) return '';
    return item.properties[PROP_BUNDLE] || '';
  }

  function isLpGift(item) {
    return Boolean(item && item.properties && item.properties[PROP_GIFT]);
  }

  function isLpCreamParent(item) {
    return Boolean(getBundleId(item) && item.properties && item.properties[PROP_CREAM] && !isLpGift(item));
  }

  function getGiftUnlockQty(item) {
    if (!item || !item.properties) return 999;
    return GIFT_UNLOCK_QTY[item.properties[PROP_GIFT]] || 999;
  }

  function getThresholdGiftUpdates(cart, creamItem, newQty) {
    var bundleId = getBundleId(creamItem);
    var updates = {};

    cart.items.forEach(function (item) {
      if (!isLpGift(item) || getBundleId(item) !== bundleId) return;
      if (newQty < getGiftUnlockQty(item)) updates[item.key] = 0;
    });

    return updates;
  }

  function getSectionsForRefresh(cartItems) {
    if (cartItems && typeof cartItems.getSectionsToRender === 'function') {
      return cartItems.getSectionsToRender().map(function (section) {
        return section.section;
      });
    }

    var sections = ['cart-icon-bubble'];
    if (document.getElementById('CartDrawer') || document.querySelector('cart-drawer')) {
      sections.push('cart-drawer');
    }
    var mainCartItems = document.getElementById('main-cart-items');
    if (mainCartItems && mainCartItems.dataset.id) sections.push(mainCartItems.dataset.id);
    var mainCartFooter = document.getElementById('main-cart-footer');
    if (mainCartFooter && mainCartFooter.dataset.id) sections.push(mainCartFooter.dataset.id);
    return sections;
  }

  function renderCartSections(parsedState, cartItems) {
    if (!parsedState || !parsedState.sections) return;

    if (
      window.SoliniaCartDrawer &&
      typeof window.SoliniaCartDrawer.render === 'function' &&
      parsedState.sections['cart-drawer']
    ) {
      window.SoliniaCartDrawer.render(parsedState);
    }

    var targets = [cartItems, document.querySelector('cart-drawer-items')].filter(Boolean);
    targets.forEach(function (target) {
      if (!target || typeof target.getSectionsToRender !== 'function') return;

      target.getSectionsToRender().forEach(function (section) {
        var html = parsedState.sections[section.section];
        if (!html) return;
        var container = document.getElementById(section.id);
        if (!container) return;
        var elementToReplace = container.querySelector(section.selector) || container;
        elementToReplace.innerHTML = target.getSectionInnerHTML(html, section.selector);
      });

      if (typeof parsedState.item_count === 'number') {
        target.classList.toggle('is-empty', parsedState.item_count === 0);
      }
    });

    if (typeof parsedState.item_count === 'number') {
      var cartDrawerWrapper = document.querySelector('cart-drawer');
      if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
      var cartFooter = document.getElementById('main-cart-footer');
      if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
    }
  }

  function publishCartUpdate(parsedState, source) {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: source || THRESHOLD_SOURCE,
        cartData: parsedState
      });
    }
  }

  var thresholdCleanupInProgress = false;

  function cleanupThresholdGifts() {
    if (thresholdCleanupInProgress) return Promise.resolve();
    thresholdCleanupInProgress = true;

    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var updates = {};

        cart.items.forEach(function (item) {
          if (!isLpCreamParent(item)) return;
          Object.assign(updates, getThresholdGiftUpdates(cart, item, getEffectiveJarCount(item)));
        });

        if (!Object.keys(updates).length) return null;

        var sections = getSectionsForRefresh();
        return fetch((window.routes && window.routes.cart_update_url) || '/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            updates: updates,
            sections: sections,
            sections_url: window.location.pathname
          })
        }).then(function (response) {
          return response.json();
        });
      })
      .then(function (parsedState) {
        if (!parsedState) return;

        renderCartSections(parsedState);
        publishCartUpdate(parsedState, THRESHOLD_SOURCE);
      })
      .catch(function (error) {
        console.error('Solinia LP gift threshold cleanup failed', error);
      })
      .finally(function () {
        thresholdCleanupInProgress = false;
      });
  }

  function patchCartQuantityThresholds() {
    if (typeof CartItems === 'undefined' || CartItems.prototype._soliniaLpSealThresholdPatched) return;

    CartItems.prototype._soliniaLpSealThresholdPatched = true;
    var previousUpdateQuantity = CartItems.prototype.updateQuantity;

    CartItems.prototype.updateQuantity = function (line, quantity, event, name, variantId) {
      if (quantity <= 0) {
        return previousUpdateQuantity.call(this, line, quantity, event, name, variantId);
      }

      var cartItems = this;
      cartItems.enableLoading(line);

      return fetch('/cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          var item = cart.items[line - 1];
          if (!item || !isLpCreamParent(item)) {
            cartItems.disableLoading(line);
            return previousUpdateQuantity.call(cartItems, line, quantity, event, name, variantId);
          }

          var giftUpdates = getThresholdGiftUpdates(cart, item, getEffectiveJarCount(item, quantity));
          if (!Object.keys(giftUpdates).length) {
            cartItems.disableLoading(line);
            return previousUpdateQuantity.call(cartItems, line, quantity, event, name, variantId);
          }

          var updates = Object.assign({}, giftUpdates);
          updates[item.key] = quantity;

          var sections = getSectionsForRefresh(cartItems);
          return fetch((window.routes && window.routes.cart_update_url) || '/cart/update.js', Object.assign({}, fetchConfig(), {
            body: JSON.stringify({
              updates: updates,
              sections: sections,
              sections_url: window.location.pathname
            })
          }))
            .then(function (response) {
              return response.text();
            })
            .then(function (state) {
              var parsedState = JSON.parse(state);
              renderCartSections(parsedState, cartItems);
              publishCartUpdate(parsedState, THRESHOLD_BATCH);
            })
            .catch(function () {
              var errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
              if (errors) errors.textContent = window.cartStrings.error;
            })
            .finally(function () {
              cartItems.disableLoading(line);
            });
        })
        .catch(function () {
          cartItems.disableLoading(line);
          var errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
          if (errors) errors.textContent = window.cartStrings.error;
        });
    };
  }

  function initCartGiftThresholds() {
    patchCartQuantityThresholds();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (
          event &&
          (event.source === THRESHOLD_SOURCE ||
            event.source === THRESHOLD_BATCH ||
            event.source === 'solinia-lp-gift-bundle' ||
            event.source === 'solinia-lp-gift-bundle-batch')
        ) {
          return;
        }
        return cleanupThresholdGifts();
      });
    }
  }

  function initRoot(root) {
    var form = root.querySelector('[data-product-form]');
    if (!form || !form.querySelector('.sealsubs-target-element')) return;

    root.addEventListener('change', function (event) {
      if (syncing) return;

      if (
        event.target.matches('.lp-product__mode-input') ||
        event.target.matches('.lp-product__variant-input')
      ) {
        var jarCount = getSelectedJarCount(root);
        if (jarCount) syncFormVariant(root, jarCount);
        waitForWidgetAndSync(root, 12);
      }
    });

    var jarCount = getSelectedJarCount(root);
    if (jarCount) syncFormVariant(root, jarCount);
    waitForWidgetAndSync(root, 16);

    document.addEventListener('sealsubs:subscription_widget_created', function (event) {
      var target = root.querySelector('.sealsubs-target-element');
      var widgetEl = event.detail && event.detail.element;
      if (!target) return;
      if (
        widgetEl === target ||
        target.contains(widgetEl) ||
        (widgetEl && widgetEl.contains(target))
      ) {
        waitForWidgetAndSync(root, 8);
      }
    });

    document.addEventListener('sealsubs:price_update', function (event) {
      var target = root.querySelector('.sealsubs-target-element');
      var widgetEl = event.detail && event.detail.element;
      if (!target || !widgetEl) return;
      if (widgetEl === target || target.contains(widgetEl) || widgetEl.contains(target)) {
        waitForWidgetAndSync(root, 4);
      }
    });

    var observer = new MutationObserver(function () {
      if (form.querySelector('select[name="subs_interval"]') || form.querySelector('.sls-option')) {
        waitForWidgetAndSync(root, 4);
      }
    });

    observer.observe(form, { childList: true, subtree: true });
  }

  function init() {
    Array.prototype.slice
      .call(document.querySelectorAll('.lp-product'))
      .forEach(initRoot);
  }

  window.SoliniaLpSeal = {
    sync: function (root) {
      return syncSealWidget(root || document.querySelector('.lp-product'));
    },
    getSellingPlanId: function (form) {
      return getSellingPlanId(form || document.querySelector('.lp-product [data-product-form]'));
    },
    cleanupThresholdGifts: cleanupThresholdGifts
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('DOMContentLoaded', initCartGiftThresholds);
  } else {
    init();
    initCartGiftThresholds();
  }
})();
